import { proxiedUrlFor } from "./media-url-utils";
import configs from "./configs";
import { resolveShortlinkTarget } from "./shortlink-url-utils";
import { extractPortalNameFromHtml } from "./portal-title-utils";

export async function resolvePortalName(portalUrl, { fetchImpl = fetch } = {}) {
  if (typeof portalUrl !== "string" || typeof fetchImpl !== "function") {
    return null;
  }

  const resolvedShortlinkUrl =
    (await resolveShortlinkTarget(portalUrl, {
      shortlinkDomain: configs.SHORTLINK_DOMAIN,
      corsProxyServer: configs.CORS_PROXY_SERVER,
      fetchImpl
    })) || portalUrl;

  const response = await fetchImpl(proxiedUrlFor(resolvedShortlinkUrl));
  if (!response.ok) {
    return null;
  }

  const html = await response.text();
  return extractPortalNameFromHtml(html);
}
